import SealCheckIcon from "@/common/images/icons/seal-check.svg?react";
import { StudioIcon } from "@/components/UI/StudioIcon";
import "./VerifiedIcon.scss";

interface IVerifiedIcon {
  isStudio?: boolean;
  title?: string;
  idPrefix?: string;
}

export const VerifiedIcon = ({ isStudio, title, idPrefix }: IVerifiedIcon) => {
  return (
    <span
      title={title}
      className="VerifiedIcon"
    >
      {isStudio ? <StudioIcon className="verifiedStudio" idPrefix={idPrefix} /> : <SealCheckIcon className="verifiedUser" />}
    </span>
  );
};
